export const mapTabs = {
  tabs: [
    {
      id: 'vulnerability',
      name: 'Vulnerability',
    },
    {
      id: 'movement',
      name: 'Movement',
    },
    {
      id: 'infrastructure',
      name: 'Infrastructure',
    },
  ]
}
